//eslint-disable
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientGroup } from '../../../code/ArcaHttpClientGroup';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaGroup } from '../../../code/Types/ArcaGroup';
import { FieldEdit } from '../../controls/Fields/FieldEdit';
import { ArcaComponent } from '../ArcaComponent';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';

export class GroupPanel2 extends ArcaComponent {

    constructor(props) {
        super(props);

        var group = this.props.group !== undefined
            ? this.props.group
            : new ArcaGroup()

        this.state = {
            formState: this.buildFields(group),
            formValid: false,
            group
        };
    }

    render() {
        return (
            <Modal isOpen={true}>
                <ModalHeader>
                    Walk Groups
                </ModalHeader>

                <ModalBody>
                    <Button color="primary" onClick={this.onConfirm.bind(this)}>Confirm</Button>{' '}
                    <Button color="secondary" onClick={this.onCancel.bind(this)}>Cancel</Button>
                    <hr />

                    <p>Enter the details of the walk group.</p>

                    {this.state.formState.Fields.map((f, k) =>
                        <FieldEdit key={k} field={f} onUpdate={this.onUpdate.bind(this)} />
                    )}

                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal >
        );
    }

    onUpdate(value, isValid, fieldName) {

        this.state.formState.GetField(fieldName).Value = value;

        var group = this.state.group;
        group[fieldName] = value;

        this.setState({
            group: group,
            disabled: false,
            formValid: this.state.formState.IsValid,
        });
    }

    buildFields(group) {
        var formState = new ArcaPageFieldState();
        formState.AddField(new ArcaField("Activity", "ActivityType", group.ActivityType, true, true, 'select', 'ActivityType'));
        formState.AddField(new ArcaField("Pets", "GroupPets", group.GroupPets, true, true, 'petSelect', group.ActivityType.startsWith('Solo') ? 1 : ArcaHttpSystem.MaxGroupItems));

        return formState;
    }

    async onConfirm() {
        this.state.group.WalkerId = this.state.group.Walker.Id;
        this.props.onConfirm(this.state.group);
        await ArcaHttpClientGroup.SaveAsync(
            this.state.group,
            () => this.props.onConfirm());
    }

    onCancel() {
        this.props.onCancel();
    }
}